var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.readOnly
      ? _c("div", [
          _c("span", { staticClass: "selected-title" }, [
            _vm._v(_vm._s(_vm.selectedText) + ": ")
          ]),
          _vm._v(" "),
          _c(
            "ul",
            {
              staticClass: "selected-options d-inline",
              attrs: { id: _vm.dropdownId + "-selected" }
            },
            _vm._l(_vm.selectedOptions, function(option, i) {
              return _c("li", [
                _c(
                  "span",
                  {
                    staticClass: "remove-option",
                    on: {
                      click: function($event) {
                        return _vm.removeOption(i)
                      }
                    }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(option.name))]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-link fas fa-times",
                        attrs: { type: "button", tabindex: "0" }
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v(
                            _vm._s(_vm.removeText) + " " + _vm._s(option.name)
                          )
                        ])
                      ]
                    )
                  ]
                )
              ])
            }),
            0
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.readOnly
      ? _c("div", { staticClass: "col-form-label" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.selectedOptions
                  .map(function(x) {
                    return x.name
                  })
                  .join(", ")
              )
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.readOnly
      ? _c("div", { class: [_vm.open ? "open" : "", "combo"] }, [
          _c("input", {
            ref: "inputref",
            staticClass: "combo-input",
            attrs: {
              "aria-activedescendant": _vm.activeOptionId,
              "aria-autocomplete": "list",
              "aria-controls": _vm.dropdownId + "-listbox",
              "aria-expanded": _vm.open ? "true" : "false",
              "aria-haspopup": "listbox",
              "aria-labelledby":
                _vm.dropdownId + " " + _vm.dropdownId + "-selected",
              role: "combobox",
              type: "text",
              placeholder: _vm.placeholder
            },
            domProps: { value: _vm.inputValue },
            on: {
              blur: function($event) {
                return _vm.onInputBlur()
              },
              click: function($event) {
                return _vm.updateMenuState(true)
              },
              input: function($event) {
                return _vm.onInput()
              },
              keydown: function($event) {
                return _vm.onInputKeyDown($event)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "listboxref",
              class: {
                "maximum-selected": _vm.selectedFull,
                "combo-menu": true
              },
              attrs: {
                role: "listbox",
                "aria-multiselectable": "true",
                id: _vm.dropdownId + "-listbox"
              }
            },
            _vm._l(_vm.filteredOptions, function(option, i) {
              return _c(
                "div",
                {
                  key: option.id,
                  ref: _vm.activeId === option.id ? "activeoptionref" : null,
                  refInFor: true,
                  class: {
                    "option-current": _vm.activeId === option.id,
                    "option-selected": _vm.optionSelected(option),
                    "combo-option": true
                  },
                  attrs: {
                    id: _vm.dropdownId + "-" + option.id,
                    "aria-selected": _vm.optionSelected(option)
                      ? "true"
                      : "false",
                    "aria-disabled":
                      _vm.selectedFull && !_vm.optionSelected(option),
                    disabled: _vm.selectedFull && !_vm.optionSelected(option),
                    role: "option"
                  },
                  on: {
                    click: function($event) {
                      return _vm.onOptionClick(option.id)
                    },
                    mousedown: function($event) {
                      _vm.onOptionMouseDown($event, _vm.optionSelected(option))
                    }
                  }
                },
                [_vm._v("\n        " + _vm._s(option.name) + "\n      ")]
              )
            }),
            0
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }